import { Route } from '@angular/router';
import { PasswordChangeRouting } from './password-change/password-change-routing';
import { PersonalInformationRouting } from './personal-information/personal-information-routing';
import { ProfileComponent } from './profile.component';

export const ProfileRouting: Route = {
    path: 'profile',
    component: ProfileComponent,
    children:[
        {path: '', redirectTo: 'personal-information', pathMatch: 'full'},
        PersonalInformationRouting,
        PasswordChangeRouting
    ],
    data: {
        breadcrumb: "Profil"
    }
}
